module.exports = __webpack_public_path__ + "img/7c1c0b7.png";